const TERMS_OF_USE_URL = 'https://docs.google.com/document/d/1V3cuMxC0Lmag6KLh9kuvl7Mj62nFENSyNhBaY3NBhBE/preview'
export default TERMS_OF_USE_URL
